import { render } from "./ds-nrasx-view.vue?vue&type=template&id=c56f3f0a&scoped=true"
import script from "./ds-nrasx-view.vue?vue&type=script&setup=true&lang=js"
export * from "./ds-nrasx-view.vue?vue&type=script&setup=true&lang=js"

import "./ds-nrasx-view.vue?vue&type=style&index=0&id=c56f3f0a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c56f3f0a"],['__file',"src/views/tep/tep-nsi/ds-nrasx-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c56f3f0a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c56f3f0a', __exports__)) {
    api.reload('c56f3f0a', __exports__)
  }
  
  module.hot.accept("./ds-nrasx-view.vue?vue&type=template&id=c56f3f0a&scoped=true", () => {
    api.rerender('c56f3f0a', render)
  })

}


export default __exports__